<template>
  <div>
        <banner>
            <div class="huoyuanxx">
                <div style="font-size:36px;">新闻资讯</div>
                <div style="margin-top:18px;font-size:18px;line-height:28px;">了解最新的新闻资讯与行业动态，掌握物流行业发展风向标</div>
            </div>
        </banner>
        <div class="shissjbg">
          <div class="shidata">
                <div class="tongzhi" v-if="isMore">
                    <!-- <el-scrollbar style="height:100%;"> -->
                        <div class="tongzlist" v-for="(n,i) in list" :key="i" @click="newsdetails(n.id)">
                            <div class="tongzbiaot">
                                <div class="chaocyc" style="width:200px;"><span style="font-size:24px;">· </span>{{n.newsTitle}}</div>
                                <div>{{datefilter(n.createTime)}}</div>
                            </div>
                            <!-- <div class="chaocyc" style="width:280px;margin-top:10px;font-size:12px;color:#AEACAC">{{n.newsContent}}</div> -->
                        </div>
                    <!-- </el-scrollbar> -->
                        <el-pagination
                            style="margin-top:30px;text-align:center;"
                            @current-change="handleCurrentChange"
                            background
                            :pager-count="4"
                            :page-size="5"
                            layout="prev, pager, next"
                            :hide-on-single-page="total < 6"
                            :total="total">
                        </el-pagination>
                </div>
                <div class="details" v-if="isMore" @click="topage(details.id)">
                    <div class="newstit">{{details.newsTitle}}</div>
                    <div class="newsdate">发布日期 :{{datefilter(details.createTime)}}</div>
                    <div class="newscont" v-html="details.newsContent">
                        <!-- <p>根据现行疫情情况，结合我单位实际防疫工作需要。现明确进（出）巨力园区（包括巨力索具园区、巨力新能源园区及刘伶醉酒厂区）的外来车辆相关规定如下：</p>
                        <p>1、外来车辆司机需遵守《巨力集团有限公司公司保卫管理规定》，并配合门卫测温消毒登记。</p>
                        <p>2、疫情期间所有司机进入厂区必须佩戴口罩(全程佩戴），司机不得随意下车（除清点货物、过泵、泵房拍照、加固货物、签字等必须下车外），更不得下车随意走动以及人群聚集，要求人与人之间保持1米以上距离，如发现不遵守规定者，将根据实际情况进行最少500元/次的罚款，影响严重者取消其承运资</p> -->
                        <!-- <div>
                            <img src="@/assets/newsimg.jpg" width="100%" />
                        </div>
                        <div>
                            <img src="@/assets/newsimg1.jpg" width="100%" />
                        </div> -->
                    </div>
                </div>
                <div v-if="!isMore" class="nodata">暂无数据</div>
          </div>
      </div>
  </div>
</template>

<script>
import Banner from '../components/banner/banner'
import { queryUsedNews,newsdetails } from '@/utils/service'
import mymixins from '@/mixins'
export default {
    mixins:[mymixins],
    data(){
        return {
            total:0,
            pageSize:5,
            list:[],
            isMore:true,
            details:{}
        }
    },
    components:{
        Banner
    },
    methods:{
        //改变pagesize
        // handleSizeChange(val){
        //     this.pageSize = val
        //     this.gethylist(1)
        // },
        //改变pageNum
        handleCurrentChange(val){
            this.gethylist(val)
        },
        gethylist(pageNo,fn){
            queryUsedNews({
                pageNo,
                pageSize:this.pageSize
            }).then(rps =>{
                if(rps.records.length > 0){
                    this.list = rps.records
                    if(fn){
                        fn(this.list[0].id)
                    }
                }else{
                    this.list = []
                }
                this.total = rps.total*1
                if(this.total == 0){
                    this.isMore = false
                }
            })
        },
        newsdetails(id){
            newsdetails({
                id
            }).then(data => {
                this.details = data
            })
        },
        topage(id){
          this.$router.push({
            path:'/details',
            query:{
              id
            }
          })
        }
    },
    created(){
        this.gethylist(1,this.newsdetails)
    }
}
</script>

<style>
    .el-scrollbar__wrap{overflow-x: hidden;}
</style>
<style lang="stylus" scoped>
    .huoyuanxx
        padding-top: 80px
        color: #fff
    .shissjbg
        background: #eef6ff
        padding: 50px 0
        .shidata
            display:-webkit-box
            display: -webkit-flex
            display: flex
            width: 1400px
            margin: 0 auto
            justify-content: space-between
            //padding: 40px 0
            //background: #fff
            .tongzhi
                width: 410px
                height: 460px
                //overflow hidden
                //overflow-y: auto
                //margin-left: 100px
                padding: 20px
                background: #fff
                .titcont
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    align-items:center
                    justify-content: space-between
                    padding-bottom: 20px
                    border-bottom: 1px solid #ccc
                .tztit
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    align-items:center
                    font-size: 16px
                    color:#08599A
            .tongzlist
                padding:15px 0
                border-bottom: 1px #ccc dotted
                cursor:pointer
                .tongzbiaot
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    align-items:center
                    justify-content: space-between
                    margin-bottom: 6px
            .sstit
                display:-webkit-box
                display: -webkit-flex
                display: flex
                align-items:center 
                justify-content:center
                font-size: 16px
                color: #08599A
                font-weight: bold
                span
                    margin-left: 10px
            .listitem
                display:-webkit-box
                display: -webkit-flex
                display: flex
                height: 90px
                line-height: 90px
                align-items:center 
                border-bottom: 1px solid #ccc
            .more
                margin-top: 30px
                text-align: center
                color: #aeacac
    .details
        width: 815px
        padding:50px
        background: #fff
        .newstit
            margin-bottom: 15px
            font-size:20px
            text-align: center
        .newsdate
            margin-bottom: 40px
            color: #aeacac
            text-align: center
        .newscont
            line-height: 22px
            p
              margin-bottom: 20px
            div
              padding-bottom: 20px
    .nodata
        width: 100%
        margin: 100px 0
        text-align: center
        font-size: 20px
    .chaocyc
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
</style>